import React, { useEffect, useState } from "react";
import { Button, Card, Col, Input, Layout, message, Result, Row, Skeleton, Table, Tag, theme, Typography } from "antd";
import AppLogo from "../../assets/images/PrefectosLogos.png";
import { useNavigate, useParams } from "react-router-dom";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import AuthService from "../../Components/auth/AuthServicePin";
import Loading from "../../Components/loading/Loading";
import { showMessage } from "../../Components/Utils/message";
import './pin.css'
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
const Auth = new AuthService();
const AuthNew = new AuthService();
const { Header, Content } = Layout;
const { Text, Title } = Typography;
const Pin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { type, roles } = useSelector((state) => state?.AppState?.userCreds);
  const hasRole5 = roles?.some(r => r.role_id === 5);
  const [pin, setPin] = useState('');
  
 const isAuthenticated = Auth.loggedIn();
 const isPinned = localStorage.getItem('access_pin');

  useEffect(() => {
    console.log("load signin ...");

    if (isAuthenticated && isPinned) return navigate("/dashboard");
  }, []);

  const layoutDispatch = useLoadingDispatch();
  const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

  const getOBStatus = async () => {
  
      showLoading(layoutDispatch)
      try {
        
        const res = await AuthNew.post(`/ob/opening-balances`, {});
        if (res.ack) {
          if (res?.opening_balances.length > 0) {
            dispatch({
              type: 'SET_OB_STATUS',
              payload: res?.opening_balances[0]?.posted_by > 0 ? true : false,
            });
          }
        } else {
          showMessage("error", res.message);
        }
      } catch (error) {
        console.log(error);
        showMessage("error", "Something went wrong");
      } finally {
        hideLoading(layoutDispatch)
      }
    };

 const handlePin = async () => {
    if(!pin) return showMessage('error', 'please enter pin to continue')
    const dataToSend = {
        pin: pin
    }
    showLoading(layoutDispatch)
    try {
    const res = await Auth.fetch('/helper/pin', {
        method: 'POST',
        body: JSON.stringify(dataToSend)
    })
    if(res?.ack) {
        localStorage.setItem('access_pin', res?.warehouse_helper?.id);
        localStorage.setItem('helper', JSON.stringify(res?.warehouse_helper));
        localStorage.setItem('pin_login_time', dayjs().valueOf());
        getOBStatus()
        navigate('/dashboard')
    } else {
        showMessage('error', res?.message)
    }
    } catch (err) {
        showMessage('error', 'something went wrong' )
    } finally {
        hideLoading(layoutDispatch)
    }
 }
  return (
    <Layout>
      <Header 
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
      >
        <div style={{ display: "flex" }} className="demo-logo">
          <img style={{ height: "36px" }} src={AppLogo} alt="appIcon" />
        </div>
      </Header>
      <Content style={{ padding: "0", height: "92vh" }}>
        <div style={{ padding: 0, minHeight: "92vh", background: colorBgContainer, borderRadius: borderRadiusLG }}>
           
      <Row justify="center" align="middle" style={{ minHeight: "calc(100vh - 175px)" }}>
          <Col xs={22} sm={16} md={10} lg={8}>
            <Card
              bordered={false}
              style={{
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                padding: "30px"
              }}
            >
              <Title level={3} style={{ textAlign: "center", marginBottom: "10px" }}>
                Enter Your PIN
              </Title>
              <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: "20px" }}>
                Use your assigned login PIN to continue
              </Text>

              <Input
                type="number"
                size="large"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                placeholder="Enter PIN"
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                  letterSpacing: "3px"
                }}
                status={!pin ? "error" : ''}
              />

              <Button
                type="primary"
                size="large"
                block
                style={{ marginTop: "20px" }}
                onClick={handlePin}
              >
                Submit
              </Button>
            </Card>
          </Col>
        </Row>
        </div>
      </Content>
      <Loading/>

    </Layout>
  );
};

export default Pin;
